let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2a7pZ")).then(() => parcelRequire('hPeTv'));